
import Vue from "vue";
import {UserConfigService} from "@/services";

export default Vue.extend({
	data(){
		return {
			userConf: UserConfigService.getSaleSettings(),
			isSaving: false
		};
	},
	methods: {
		cancel(){
			this.$emit("close");
		},
		async confirm(){
			if (this.isSaving) return;
			this.isSaving = true;
			try{
				await UserConfigService.setSaleSettings(this.userConf);
				this.$emit("saved");
				this.$emit("close");
			}catch(err){

			}finally{
				this.isSaving = false;
			}
		}
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
